import { CwtAuthConfig } from "@cawita/core-front/auth";

export const AuthConfig: CwtAuthConfig = {
    api: {
        forgotPasswordEndpoint: 'user/reset/send-email',
        loginEndpoint: 'user/logged',
        logoutEndpoint: 'user/logged',
        registerEndpoint: 'user',
        resetPasswordEndpoint: 'user/reset',
        validateEmailEndpoint: 'user/validate/email'
    },
    store: {
        stateStorageKey: 'cwt-katcha-user-auth-store'
    },
    navigation: {
        defaultRoute: ['/home'],
        permissionDeniedRoute: ['/home'],
        loginRoute: ['/auth']
    },
};